let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5JTxv"), load("MrUJ0"), load("is5C8"), load("70aiP"), load("8oWxD"), load("jzQ6f")]).then(() => parcelRequire('ylKHA'));